import React from 'react';
import styles from './ErrorLabel.module.scss';
interface Props {
  errorMessage?: string;
}
export const ErrorLabel = ({ errorMessage }: Props) => {
  return <span className={styles['error-message']}>{errorMessage}</span>;
};
